import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Actions as HELPACTIONS } from '../../store/actions/helpActions';
import { useLocation } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import gfm from 'remark-gfm';
import { Sheet, SheetContent } from '../ui/sheet';

const HelpSidebar = ({ show, fetchHelp, helpItems, showHelp }) => {
  const [currentHelp, setCurrentHelp] = useState({ content: 'No Help Available' });

  const handleOpenChange = (open) => {
    if (!open) showHelp(false);
  };

  const location = useLocation();

  useEffect(() => {
    fetchHelp();
  }, [fetchHelp]);

  React.useEffect(() => {
    if (helpItems) {
      switch (location.pathname) {
        case '/':
          setCurrentHelp(helpItems?.find((i) => i.handle === 'home'));
          break;
        default:
          const firstSlash = location.pathname.substr(1).indexOf('/');
          const level1Path = location.pathname.substr(1, firstSlash === -1 ? location.pathname.length : firstSlash);
          if (level1Path === 'report') {
            setCurrentHelp(helpItems?.find((i) => i.handle === 'report-html'));
          } else {
            const helpItem = helpItems?.find((i) => i.handle === level1Path);
            if (helpItem) {
              setCurrentHelp(helpItem);
            }
          }
      }
    }
  }, [location, helpItems]);

  return (
    <Sheet open={show} onOpenChange={handleOpenChange}>
      <SheetContent
        side="right"
        className="right-sidebar w-[320px] p-5 h-full bg-[#5C8C6E] text-white border-0"
        aria-hidden={!show}>
        <label className="text-3xl">Help</label>
        <hr className="mb-2.5" />
        <ReactMarkdown remarkPlugins={[gfm]} className="text-base">
          {currentHelp.content}
        </ReactMarkdown>
      </SheetContent>
    </Sheet>
  );
};

const mapStateToProps = (state) => {
  return {
    show: state.help?.show,
    helpItems: state.help?.list,
  };
};

const mapDispatchToProps = (dispatch) => ({
  fetchHelp: () => dispatch(HELPACTIONS.fetchHelp()),
  showHelp: (status) => dispatch(HELPACTIONS.showHelp(status)),
});

export default connect(mapStateToProps, mapDispatchToProps)(HelpSidebar);
